/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonDocumentApprovalOcrDataViewModel } from "../types/PersonDocumentApprovalOcrDataViewModel.ts";

export const personDocumentApprovalOcrDataViewModelSchema = z.object({
  firstName: z
    .string()
    .describe("Primeiro nome extraído, capitalizado. Opcional.")
    .nullish(),
  surname: z
    .string()
    .describe("Sobrenome extraído, capitalizado. Opcional.")
    .nullish(),
  birthDate: z
    .string()
    .describe("Data de nascimento extraída (dd/MM/yyyy). Opcional.")
    .nullish(),
  rg: z.string().describe("Número do RG extraído. Opcional.").nullish(),
  dispatcherDateDoc: z
    .string()
    .describe("Data de expedição extraída (dd/MM/yyyy). Opcional.")
    .nullish(),
  gender: z
    .string()
    .describe("Gênero extraído por extenso (Masculino/Feminino). Opcional.")
    .nullish(),
  dispatcherOrg: z
    .string()
    .describe("Órgão expedidor extraído. Opcional.")
    .nullish(),
  dispatcherState: z
    .string()
    .describe("UF do órgão expedidor extraída. Opcional.")
    .nullish(),
  birthCity: z
    .string()
    .describe("Cidade de nascimento extraída. Opcional.")
    .nullish(),
  birthState: z
    .string()
    .describe("Estado de nascimento extraído. Opcional.")
    .nullish(),
  nationality: z
    .string()
    .describe("Nacionalidade extraída. Opcional.")
    .nullish(),
  birthCountry: z
    .string()
    .describe("País de nascimento extraído. Opcional.")
    .nullish(),
  filiations: z
    .array(z.string())
    .describe("Nomes de filiação extraídos (pai/mãe), capitalizados.")
    .nullish(),
  otherLocations: z
    .array(z.string())
    .describe("Localidades extraídas sem classificação geográfica definida.")
    .nullish(),
}) as unknown as ToZod<PersonDocumentApprovalOcrDataViewModel>;
